import NextLink from 'next/link'
import classnames from 'classnames'
import { ChevronRightIcon } from '@icons'

import styles from './index.module.scss'

type BaseProps = {
  children: string
  href: string
  size?: 'large' | 'medium'
}

export const CategoryTitleButton = ({ children, href, size = 'large' }: BaseProps) => {
  return (
    <NextLink
      href={href}
      prefetch={false}
      className={classnames(styles['link-wrapper'], styles[size])}
    >
      {children}
      <ChevronRightIcon className={styles['chevron-icon']} />
    </NextLink>
  )
}

export default CategoryTitleButton
